// extracted by mini-css-extract-plugin
module.exports = {"anchor":"anchor_anchor__C8Zi7","sliderWrap":"anchor_sliderWrap__1ovsU","selectWrap":"anchor_selectWrap__19Wfm"};